import { render, staticRenderFns } from "./IconTypeformRating.vue?vue&type=template&id=33142184&"
import script from "./IconTypeformRating.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformRating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports